<template>
 <div class="index" >
    <!-- carousel 首页轮播区开始 -->

    <div class="carousel" >
        <div class="carousel-log" v-if="logoFlag.flag" :class="{'carousel-load':carouselLoad}">
            <img style="height: 173px;width: 183px" src="@/assets/imgs/logo.png" alt="">
        </div>
         <div class="recommendPage" >
            <swiper :options="swiperOption" ref="mySwiper" v-if="bannerImgs.length > 0">
            <swiper-slide  v-for="(item,index) in bannerImgs" :key="'banner'+index">
                 <div >
                   <img  :src = "item.path"  alt="banner-alt" class="swiper-img"  >
                 </div>
                <!-- <img v-progressive= "item.path" src="@/assets/imgs/onload.jpeg" alt="banner-alt" :style="carouselStyle" @click="jumpItem(item.link, item.id)" > -->
                <!-- <el-image :src="item.path" alt="banner-alt" :style="carouselStyle" @click="jumpItem(item.link, item.id)" >


                </el-image> -->
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
              <div class="tagsWrap">
                <div class="tags">
                </div>
                <div class="white">
                </div>
              </div>
        </div>
    </div>
    <!-- carousel 首页轮播区结束 -->


    <!-- 展览信息区开始 -->

    <div class="exhibition-infor wx1200">
        <div class="w920">
            <div class="tip">

                    <p class="title-top">展览信息</p>
                    <div class="title-bottom">
                        <span class="left">Exhibition information</span> <span class="right" @click="jumpItem('/display')">more+</span>
                    </div>



                <!-- <img src="@/assets/imgs/exhibition-tip.png" alt="ex-tip" > -->
                <!-- <img src="@/assets/imgs/more.png"  class="tip-right" @click="jumpItem('/display')"> -->
            </div>

        </div>
           <div class="content">
                <div class="content-left">
                    <ul>
                        <li  :class="index == currentValue ? 'current-li' : ''"  @click="change(index)" v-for="(item,index) in exhiImgs" :key="index" >{{item.name}}</li>
                    </ul>

                    <div :class="index == currentValue ? 'current' : ''" class="content-tip-box" v-for="(item,index) in exhiImgs" :key="'tip-box'+index" >
                        <div  class="content-tip" >
                            <span :title="item.title" @click="jumpItem(index == 0 ? '/displayDetail' : '/yugaoDetail' ,item.id)">{{item.title}}</span>
                            <span>展期：{{item.startTime}} 至 {{item.endTime}}</span>
                            <span>展厅：{{item.address}}</span>
                       </div>
                    </div>

                    <div class="conent-img" :class="index == currentValue ? 'current' : ''"  v-for="(item, index) in exhiImgs"  :key="'img'+index">
                        <div class="box-img">
                        </div>
                         <img v-lazy="item.path">
                        <!-- <img :src="item.path" >  -->
                    </div>
                </div>
                <div class="content-right" >
                    <div class="text-box" v-if="currentValue == 0" :class="{'animate-up': animateUp}"  >
                               <div class="min-box" v-for="(item,index) in exhiTexts.now" :key="'min-box'+index"  @mouseenter="mouseoverAnimate(0)" @mouseleave="mouseoutAnimate(0)">
                                    <span @click="jumpItem('/displayDetail',item.id)" :title="item.title" :key="item.title+index">【展览】{{item.title}}</span>
                                  <span > <span v-html="'&nbsp;'"></span>展期：{{item.startTime}} 至 {{item.endTime}}</span>
                                </div>


                    </div>
                    <div class="text-box" :class="{'animate-up': animateUp}"   v-else>
                                <div class="min-box" v-for="(item,index) in exhiTexts.preview" :key="'min-box'+index" @mouseover="mouseoverAnimate(1)" @mouseout="mouseoutAnimate(1)">
                                <span @click="jumpItem('/yugaoDetail',item.id)" :title="item.title">【预告】{{item.title}}</span>
                                <span ><span v-html="'&nbsp;'"></span>展期：{{item.startTime}} 至 {{item.endTime}}</span>
                            </div>
                    </div>
                </div>
            </div>


    </div>

     <!-- 展览信息区结束 -->
     <!-- 藏品类别区开始  -->
    <div class="artwork wx1200">
          <div class="w920">
              <div class="tip">
                        <div class="tip-left">
                            <p>藏品类别</p>
                            <p>Collection category</p>
                        </div>
              </div>
          </div>
            <div class="content">
                <div class="carousel-box">
                    <el-carousel :interval="4000"  type="card" height="320px" :autoplay="false" arrow="always" indicator-position="none" :loop="false" ref="artCarouse">
                        <el-carousel-item v-for="(item, index) in artImgs" :key="'art-carousel'+index" >
                            <div class="img-box"   @click="jumpItemSecond('/appreciate/collectionList',item.id,item.text)">
                                <div class="img-box-item"> {{ item.text}}</div>
                                <img v-lazy="item.path"  alt="art-alt" class="img-pic">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
    </div>
     <!-- 藏品类别区结束 -->
     <!-- 新闻公告区开始 -->
     <div class="news-infor wx1200">
        <div class="w920">
            <div class="tip">
                <!-- <img src="@/assets/imgs/news-info.png" alt="ex-tip" class="tip-left">
                <img src="@/assets/imgs/more.png" alt="more" class="tip-right" @click="jumpItem('/newsInfo')"> -->
                   <p class="title-top">新闻公告</p>
                    <div class="title-bottom">
                        <span class="left">News bulletin</span> <span class="right" @click="jumpItem('/notice')">more+</span>
                    </div>
            </div>

        </div>
         <div class="content">
                <div class="content-left">
                    <img :src="newsImg" alt="news-show" class="news-show">
                </div>
                <div class="content-right" >
                    <div class="text-box">
                              <div class="min-box" v-for="(item,index) in newsTexts" :key="'min-box'+index">
                                <span @click="jumpItem('newsInfo/details',item.id)" :title="item.title">{{item.title}}</span>
                                <span >日期：{{item.date}}</span>
                            </div>
                    </div>
                </div>
            </div>

    </div>
    <!-- 新闻公告区结束 -->
    <!-- 公共活动区开始 -->
    <div class="public-activity wx1200">
          <div class="w920">
              <div class="tip">
                     <!-- <img src="@/assets/imgs/public-activity.png" alt="art-tip" > -->
                     <div class="tip-left">
                            <p>公共活动</p>
                            <p>Public activities</p>
                        </div>
              </div>
          </div>

            <div class="content">
                <div class="carousel-box">
                    <el-carousel :interval="4000"  type="card" height="320px" :autoplay="false" arrow="always" indicator-position="none" :loop="false" ref="activityCarouse" >
                        <el-carousel-item v-for="(item, index) in activityImgs" :key="'art-carousel'+index" name="index">
                            <div class="img-box"  @click="jumpItem('/education/detail',item.id)">
                                <div class="img-box-item"> {{ item.text}}</div>
                                <img v-lazy="item.path" alt="art-alt" class="img-pic">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                      <!-- <div class="leftTriangle" @click="arrowClick('left')" id="activity-leftTriangle">
                    &lt;
                </div>
                <div class="rightTriangle" @click="arrowClick('right')" id="activity-rightTriangle">
                    &gt;
                </div>   -->
                </div>





            </div>

    </div>

    <!-- 公共活动区结束 -->
    <!-- 美术馆简介区开始 -->
    <!-- <div class="art-brief wx1200">
        <div class="w920">
            <div class="tip">
                    <div class="tip-left">
                            <p>美术馆简介</p>
                            <p>Brief introduction of Art Museum</p>
                        </div>
            </div>

        </div>
         <div class="content">
                <div class="conent-text">
                    <div class="text-box" v-html="artBief"></div>
                </div>
                <img src="@/assets/imgs/bannerbg.png" alt="art-brief" class="conent-img">
        </div>

    </div> -->
    <!-- 美术馆简介区结束 -->
    <!-- 学术交流区开始 -->
    <div class="academic-exchange wx1200">
        <div class="w920">
            <div class="tip">
                  <div class="tip-left">
                            <p>学术交流</p>
                            <p>Academic exchange</p>
                        </div>
                <!-- <img src="@/assets/imgs/academic-exchange-tip.png" alt=""> -->
            </div>
            <div class="content">
                <div class="content-left" @click="jumpItem('/activities')">
                    <div class="image-mask">学术活动</div>
                    <img :src="academicImgs[0].path" alt="">
                </div>
                 <div class="content-right" @click="jumpItem('/study')">
                     <div class="image-mask">学术研究</div>
                    <img :src="academicImgs[1].path" alt="">
                </div>
            </div>

        </div>
    </div>
    <!-- 学术交流区结束 -->
    <!-- 服务指南区开始 -->
    <div class="service-guide wx1200">
        <div class="w920">
            <div class="tip">
                <!-- <img src="@/assets/imgs/servie-guide-tip.png" alt=""> -->
                 <div class="tip-left">
                            <p>服务指南</p>
                            <p>Service Information</p>
                        </div>
            </div>


        </div>
           <div class="content" :key="map.longitude">
                <baidu-map @ready="mapHandle" style="width:100%;height:400px" :scroll-wheel-zoom='true' ></baidu-map>
                 <div class="map-tip">
                     <div class="left">
                        <div class="title">
                            开馆时间
                        </div>
                        <div class="tip-content" v-html="kaiguanshij">
                            <!-- 友情提示：上饶美术馆周一闭馆（不含节假日）疫情期间实行分时预约参观。 <br/>每日可预约时间段如下：9:00-11:00；11:00-14:00；14:00-16:00 <br/>地址：上饶市信州区平江道60号 <br/>电话：022—83883300 -->
                        </div>
                     </div>
                     <div class="right">
                         <div class="button" @click="jumpItem('/spectatorService/appointment')">
                             <a>参观预约</a>
                         </div>
                     </div>
                 </div>
            </div>
    </div>
    <!-- 链接介绍区开始 -->
    <div class="dw">
        <div class="link-record wx1200">

                <div class="record">
                    <div class="content" v-html="cangaunxuzhi">
                    </div>
                    <div class="erweima">
                        <img src="@/assets/imgs/erweima.png" alt="">
                    </div>
                </div>
                 <div class="link"> <span>友情链接：</span> <a :href="item.link" v-for="(item,index) in youqinglianjie" :key="'link'+index">{{item.title}}</a> </div>
        </div>

    </div>
    <!-- 链接介绍区结束  -->
 </div>
</template>

<script>
import axios from 'axios'

var indexSwiper82778=null;
export default {
  name: 'index',
  props: {
    msg: String
  },
   data() {
      return {
          //carouselStyle:{width:'100%',height:'740px'},//轮播组件高度
          //carouselHeight:740,//banner轮播组件高度
          logoFlag:{flag:true},//logo图片显示开关
          bannerImgs:[],//横幅区轮播图片
          exhiImgs:[],//展览图片信息
          exhiTexts:{}, //展览文字信息
          artImgs:[],//艺术品图片信息
          newsImg:require("../assets/imgs/newsNotice.png"), //新闻展示图片
          newsTexts:[],//新闻文字信息
          activityImgs:[], //活动图片信息
          academicImgs:[{path:require("../assets/imgs/xsdz.png")},{path:require("../assets/imgs/xsms.png")}],//学术交流图片
          currentValue:0, //存储tab切换选中tab页index值
          screenWidth:0,//屏幕宽度
          map:{
            longitude: 1,
            latitude: 1,
            address:'',
           },//地图信息
           kaiguanshij:'',//开馆时间区域变量
           cangaunxuzhi:'',//参观须知区域变量
           artBief:'',//美术馆简介变量
           youqinglianjie:[],//友情链接变量
           nowTimer:null,//正在展览定时器
           previewTimer:null,//预告览定时器
          animateUp: false,//展览文字轮播开关阀
           animateTime:1500,//展览定时时间
           carouselLoad:false,//logo顶部划入控制开关
           timeoutTimer:null,//setTimerout 定时器
            carouseChangeTimer:null,//展览setTimerout 定时器
                carouseLoadTimer:null,//展览setTimerout 定时器
            swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        isRunCreated:false,//是否执行了created方法
              on:{
            click:function (){
              const realIndex =this.realIndex;
              indexSwiper82778.handleClickSlide(realIndex);
            }
              }
      }




      };
    },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods:{
    handleClickSlide(index){
      let item = this.bannerImgs[index];
      this.jumpItem(item.link, item.id)
    },
     async getAttachment(id)
      {
         var info =  await this.$axios({
            method: "get",
            url: "/common/fileInfo/"+id,
            data: {},
            })
        return info.data.data[0].filePath;
      },//获取附件方法
    async getExhibitionInfoOnNew(type, name) {
    let params =
    {   pageNum:1,
        pageSize:1,
       'params[type]':type
    };
    await  this.$sr_api.getExhibitionInfo(params).then((res) => {
        //console.log(res,'res');
            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                obj.startTime = res.rows[i].startTime;
                obj.endTime = res.rows[i].endTime;
                obj.title = res.rows[i].title;
                obj.address = res.rows[i].hall;
                obj.name = name;
                obj.id = res.rows[i].id;
                let bgImg = res.rows[i].params.reallyFilePath;
                if (bgImg.indexOf(',') != -1)
                {

                    let s = bgImg.split(',');
                    obj.path= this.$axios.defaults.baseURL +s[0];
                }
                else
                {
                    obj.path= this.$axios.defaults.baseURL+bgImg;
                }
                //obj.path = axios.defaults.baseURL+res.rows[i].params.reallyFilePath;
                this.exhiImgs.push(obj);
            }
        });
   },//获取最新展览方法
    async getExhibitionInfo(type, name) {
        let params = {  pageNum:1,
               pageSize:10,
               'params[type]':type};
           await  this.$sr_api.getExhibitionInfo(params).then((res) => {
            let arr =[];
            let exhi = {};
            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                obj.startTime = res.rows[i].startTime;
                obj.endTime = res.rows[i].endTime;
                obj.title = res.rows[i].title;
                obj.address = res.rows[i].hall;
                obj.id = res.rows[i].id;
                obj.name = name;
                arr.push(obj);
            }
            if (type == 2)
            {
                this.exhiTexts.now = arr;
            }
            else
            {
                this.exhiTexts.preview = arr;
            }
        });
   },//获取展览列表方法
   async getArtInfo()
   {
       let params =  {pageNum:1,
               pageSize:10,
                status:0};
          await  this.$sr_api.getArtInfo(params).then((res) => {
            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                obj.text = res.rows[i].categoryName;
                obj.id = res.rows[i].categoryId;
                obj.path = axios.defaults.baseURL+res.rows[i].params.reallyFilePath;
                this.artImgs.push(obj);
            }

        });//获取藏品方法
   },
   async getNewsInfo(type)
   {
       let params =
            {  pageNum:1,
               pageSize:10,
               type:type
            };
        await this.$sr_api.getNewsInfo(params).then((res) => {

            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                obj.title = res.rows[i].title;
                obj.id = res.rows[i].id;
                obj.date = res.rows[i].publishTime;
                this.newsTexts.push(obj);
            }

        });
   },//获取新闻通告方法
    async getPublicActivity()
    {
        let params  =
            {  pageNum:1,
               pageSize:10,
               publishStatus:1
            };
        await this.$sr_api.getPublicActivity(params).then((res) => {

            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                obj.text = res.rows[i].title;
                obj.id = res.rows[i].id;
                obj.path = axios.defaults.baseURL+res.rows[i].params.reallyFilePath;
                this.activityImgs.push(obj);
            }
        });
    },//获取公共活动方法

   arrowClick(val) {
      if(val === 'right') {
        this.$refs.activityCarouse.next()
      } else {
        this.$refs.activityCarouse.prev()
      }
    },//轮播图切换下一页
    carouselChange()
    {
        //var leftTriangle = document.getElementById("activity-leftTriangle");
        //var rightTriangle = document.getElementById("activity-rightTriangle");
       this.$refs.activityCarouse.next();
       this.$refs.artCarouse.next();
       //console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh');
        //this.$refs.cardShow.setActiveItem(1);
    },//默认下一页
    async getArtBief(name)
    { 
        // name = encodeURIComponent(name);
        let params=
            {  name:'美术馆简介'
            };
        await this.$sr_api.getArtBriefInfo(params).then((res) => {
            this.artBief = res.data.value;
        });
    },//获取美术馆简介方法
    async getKaiguanshij(name)
    { 
        // name = encodeURIComponent(name);
        let  params =
            {  name:'开馆时间'
            };
        await this.$sr_api.getArtBriefInfo(params).then((res) => {
            this.kaiguanshij= res.data.value;
        });
    },//获取开馆时间方法
    async getCanguanxuzhi()
    {
        let  params =
            {  name:'参观须知'
            };
        await this.$sr_api.getArtBriefInfo(params).then((res) => {
            this.cangaunxuzhi = res.data.value;

        });
    },//获取参观须知方法
    async getYouqinglianjie(){
         let params =
            {  pageNum:1,
            pageSize:10,
            };
     await this.$sr_api.getYouqinglianjie(params).then((res) => {
            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                 obj.link = res.rows[i].link;
                 obj.title = res.rows[i].title;
                this.youqinglianjie.push(obj);
            }
        });
    },//获取友情链接方法
    async getBannerInfo()
    {
        let   params=
            {  pageNum:1,
               pageSize:10
            };
        await this.$sr_api.getBannerInfo(params).then((res) => {
            let length = res.rows.length;
            for(let i = 0; i < length; i++)
            {
                let obj = {};
                obj.link = res.rows[i].link;
                obj.id = res.rows[i].id;
                obj.path = axios.defaults.baseURL+res.rows[i].params.reallyFilePath;
                this.bannerImgs.push(obj);
            }
        });
    },//获取banner区轮播列表方法
   async  getServiceGuide()
    {
      await this.$sr_api.getServiceGuide().then((res) => {

             if (res.mapCoordinate)
             {
                var arr = res.mapCoordinate.split(",");
                this.$set(this.map,'longitude',parseFloat(arr[0]))
                this.$set(this.map,'latitude',parseFloat(arr[1]))
                this.$set(this.map,'address', res.address);

             }
        });
     },//获取地图信息
      	 handleScroll () {

	   	var oldtop = 10,top=0;
		top = document.documentElement.scrollTop|| document.body.scrollTop
		if(top>=oldtop){
			this.logoFlag.flag = false
		}else{
			this.logoFlag.flag = true
		}
	},//滚动时判断是否显示隐藏logo
    showMarquee: function (arr) {
                this.animateUp = true;

                this.timeoutTimer =window.setTimeout (() => {
                    arr.push(arr[0]);
                    arr.shift();
                    this.animateUp = false;
                    //console.log(this.timeoutTimer,' this.timeoutTimer 2');
                    window.clearTimeout(this.timeoutTimer);
                }, 500);
                // console.log( this.timeoutTimer ,' this.timeoutTimer 1');
            },//文字轮播处理函数
        change:function(index)
        {
            this.currentValue = index;
            this.animateUp = false;
            if(index == 0)
            {

                window.clearInterval(this.previewTimer);
                if (this.exhiTexts.now.length > 5)
                {
                        this.startNowTimer();
                }

            }
            else
            {
                window.clearInterval(this.nowTimer);
                if (this.exhiTexts.preview.length > 5)
                {
                    this.startPreviewTimer();
                }
            }
            //this.initAnimate();
        },//展览tab切换调用方法
         setSize:function () {
            // 通过浏览器宽度(图片宽度)计算高度宽度
            // this.cardHeight = 320 / 1440 * this.screenWidth;
            // this.cardWidth = 285 / 1440 * this.screenWidth;
             //this.carouselHeight = 740 / 1440 * this.screenWidth;
            // this.imgboxStyles.width =  this.cardWidth + 'px';
           // this.carouselStyle.height = this.carouselHeight +'px';

          },//窗口改变设置轮播组件高度宽度方法
          mapHandle({ BMap, map }) {
            var point = new BMap.Point(this.map.longitude, this.map.latitude);
            map.centerAndZoom(point, 13)
            var icon = new BMap.Icon(require("../assets/imgs/map-position.png"),new BMap.Size(74,84));
            var marker = new BMap.Marker(point,{icon:icon}) // 创建标注
            map.addOverlay(marker) // 将标注添加到地图中
             var html = [];
              var opts ={
               width :250,
               height:30,
             }
            html.push('<div class="mapTipWindow"> <ul>');
            html.push("<li>"+ this.map.address +"</li>");
            html.push("</ul></div>");
            var infowindow = new BMap.InfoWindow(html.join(""),opts);
            marker.addEventListener("click",function(){
                this.openInfoWindow(infowindow);
            });
          },//百度地图函数
          mouseoverAnimate(index)
          {

              this.animateUp = false;
              if(index == 0)
              {
                window.clearInterval(this.nowTimer);
              }
              else
              {
                  window.clearInterval(this.previewTimer);
              }

          },//移入正在展览处理函数
          mouseoutAnimate(index)
          {
               this.animateUp = false;
               if(index == 0 )
               {
                    this.startNowTimer();
               }
               else
               {
                   this.startPreviewTimer();
               }

          },//移出正在展览处理函数
          startNowTimer()
          {
                    if (this.exhiTexts.now.length > 5)
                    {
                        window.clearInterval(this.nowTimer);
                        this.nowTimer = window.setInterval (()=>{this.showMarquee(this.exhiTexts.now);}, this.animateTime);

                    }

          },//开启正在展览定时器
         startPreviewTimer()
          {
                    if (this.exhiTexts.preview.length > 5)
                    {
                        window.clearInterval(this.previewTimer);
                        this.previewTimer = window.setInterval (()=>{this.showMarquee(this.exhiTexts.preview);}, this.animateTime);
                    }
          },//开启展览预告定时器
      carouselLoadFunc()
      {

         // this.carouselLoad = true;
      },//页面加载完控制开关
      jumpItem(link,id)
      {
        console.log(link,id)
          if(id)
          {

              this.$router.push({path:link,query:{id:id}})
          }
          else
          {
              this.$router.push({path: link});
          }
      },//路由跳转函数
    jumpItemSecond(link,id,name)
    {


              this.$router.push({path:link,query:{id:id,name:name}})

    },//第二种路由跳转函数



  },
 watch:{
  $route(to,from){
  }
},
     mounted() {
       // console.log(2)
          // 首次加载时,需要调用一次
          //this.screenWidth =  window.innerWidth;
          //this.setSize();
          // 窗口大小发生改变时,调用一次
        //   window.onresize = () =>{
        //   this.screenWidth =  window.innerWidth;
        //   this.setSize();
        // }

           //console.log("this is current swiper instance object", this.swiper);

     },
     async created()
     {
       indexSwiper82778=this
         console.log(11111111111);
         this.isRunCreated = true;
        console.log('aaaa')
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('load', this.carouselLoadFunc);
        await this.getExhibitionInfo(2,'正在展览');
        await this.getExhibitionInfo(1, '展览预告');
        await this.getExhibitionInfoOnNew(2,'正在展览');
        await  this.getExhibitionInfoOnNew(1, '展览预告');
        this.startNowTimer();
        this.getArtInfo();
        this.getNewsInfo(1);
        this.getPublicActivity();
        this.getArtBief();
        this.getKaiguanshij();
        this.getCanguanxuzhi();
        this.getServiceGuide();
        this.getYouqinglianjie();
        this.getBannerInfo();
          this.carouseChangeTimer = window.setTimeout(()=>{ this.carouselChange();  window.clearTimeout(this.carouseChangeTimer)},1000);
         //this.carouseTimeoutTimer = window.setTimeout(()=>{this.carouselChange();   this.carouselLoad = true; window.clearTimeout(this.carouseTimeoutTimer)},1000);
     },
     beforeDestroy() {
       this.carouselLoad = false;
    this.animateUp = false;
    this.isRunCreated = false;
    window.clearInterval(this.nowTimer);
    window.clearInterval(this.previewTimer);

  },
    activated: async function () {
        console.log(this.isRunCreated,'this.isRunCreated');
        if (!this.isRunCreated)
        {
            this.exhiTexts = {};
            this.exhiImgs =[];
            await this.getExhibitionInfo(2,'正在展览');
            await this.getExhibitionInfo(1, '展览预告');
            await this.getExhibitionInfoOnNew(2,'正在展览');
            await  this.getExhibitionInfoOnNew(1, '展览预告');
            console.log(this.exhiTexts,'this.exhiTexts');
            this.startNowTimer();
        }

      this.carouseLoadTimer = window.setTimeout(()=>{ this.carouselLoad = true; window.clearTimeout(this.carouseLoadTimer)},1000);
      console.log(3)
    },
    deactivated: function () {
    this.carouselLoad = false;
    this.animateUp = false;
    this.isRunCreated = false;
    window.clearInterval(this.nowTimer);
    window.clearInterval(this.previewTimer)
      console.log(4)
    }
}
</script>


<style scoped>

img {
    font-size: 18px;
}
::v-deep .mapTipWindow li {
    font-size: 18px;
}
.index {
    font-family: Source Han Sans CN;
    font-weight: 400;
    background-color: #f4f4f4;
}
.w920 {
    width: 920px;
}
.w1200 {
    width: 76.67%;
}
.wx1200 {
    width: 1200px;
}
/* carousel 首页轮播区样式开始 */
.carousel {
     position: relative;
     width: 100%;
     height: 11.111111rem /* 800px -> 11.111111rem */;
     background-color: transparent;
     overflow: hidden;
}
.carousel .carousel-log {
    position: absolute;
    z-index: 993;
    height: auto;
    /* top: 15%; */
    opacity: 0;
    top: -100%;
    transition: all 2.5s ease;
    left: 10%;
}
 .carousel .carousel-load {
    top: 17%;
    opacity: 1;
    /* top: 15%;
    opacity: 1; */
}

.carousel .carousel-log > img {
    width: 15%;
    height: auto;
}
.carousel .banner {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: purple;
    background-repeat: no-repeat;
    background-position: center top;
}
.recommendPage {
    width: 100%;
    height: 10.277778rem /* 740px -> 10.277778rem */;
}
.swiper-img {
     width: 100%;
    height: 10.277778rem /* 740px -> 10.277778rem */;
}
::v-deep .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets
{
     top: 7.5rem /* 540px -> 7.5rem */;
}

::v-deep .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 15px;
}
::v-deep .swiper-pagination-bullet
{
    width: 18px;
    height: 18px;
    border-radius: 9px;
    background: #000000;
    opacity: 0.6;
}
::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: #B78C0D;
}
::v-deep .swiper-button-prev {

}
/* .ant-carousel >>> .slick-dots.slick-dots-bottom button {
  width: 18px;
    height: 18px;
    border-radius: 9px;
   background: #000000;
opacity: 0.6;
}
.ant-carousel >>> .slick-dots {
    top: 630px;
}
.ant-carousel >>> .slick-dots  li {
    margin: 0 15px;
}
.ant-carousel >>> .slick-dots  li.slick-active button{
    background-color: #B78C0D !important;
    opacity: 1;
        width: 18px;
    height: 18px;
    border-radius: 9px;
} */
.tagsWrap {
    width: 100%;
    height: 60px;
    background-color: transparent;
}
.tags {
    position: absolute;
    z-index: 991;
    top: 9.444444rem /* 680px -> 9.444444rem */;
    left: 0;
    margin-left:-50%;
    height: 100%;
    width: 200%;
    background-color: #B78C0D;
    border-radius: 100% 100% 100% 100% /  100% 100% 0 0;
}
.white {
    position: absolute;
    z-index: 991;
    top: 9.513889rem /* 685px -> 9.513889rem */;
    left: 0;
    margin-left:-50%;
    height: 100%;
    width: 200%;
    background-color: #f4f4f4;
    border-radius: 100% 100% 100% 100% /  100% 100% 0 0;

}
/* carousel 首页轮播区样式结束 */
/* exhibition-infor 展览信息区样式开始 */
.exhibition-infor {
    display: flex;
      margin: 0 auto;
    justify-content: center;
        flex-wrap: wrap;
    background-color: #f4f4f4;
}

.exhibition-infor .tip {
    width: 100%;
    height: 80px;

}
.exhibition-infor .tip .title-top {
    width: 333px;
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;

}
.exhibition-infor .tip .title-bottom
{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.exhibition-infor .tip .title-bottom .left
{
    width: 333px;
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
.exhibition-infor .tip .title-bottom .right
{
    width: 98px;
    height: 40px;
    font-size: 36px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
    line-height: 40px;
    cursor: pointer;
}

.exhibition-infor .content {
    width: 100%;
    height: 400px;
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
}
.exhibition-infor .content .content-left {
    position: relative;
    flex: 880px;
    height: 100%;


}

.exhibition-infor .content-left ul {
      position: absolute;
          z-index: 3;
      display: flex;
      left: 9%;
      bottom: 12%;
 }
.exhibition-infor .content-left ul li{
   width: 80px;
   height: 30px;
   line-height: 30px;
   text-align: center;
    margin-right: 20px;
    color: #ffffff;
    font-size: 14px;
    border: 1px solid #ffffff;
    cursor: pointer;
  }
  .exhibition-infor .content-left ul .current-li {
     border: 1px solid #B78C0D;
     background-color: #B78C0D;


  }
  .exhibition-infor  .content-left .content-tip{
      z-index: 3;
      position: absolute;
      left: 9%;
      top: 17%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: #ffffff;
      font-size: 14px;
      overflow: hidden;


  }
   .exhibition-infor  .content-left  .content-tip-box {
      display: none;
  }

    .exhibition-infor .content-left .content-tip span {
       margin-bottom: 10px;
   }
    .exhibition-infor .content-left .content-tip span:nth-child(1) {
        width: 700px;
            overflow: hidden;
     white-space: nowrap;
        /* 这两个要一起用 */
    text-overflow: ellipsis;
         font-size: 18px;
         margin-bottom: 20px;
         cursor: pointer;

  }
    .exhibition-infor .content-left .conent-img {
        position: relative;
        width: 100%;
        height: 100%;
        display: none;
        overflow: hidden;
         border-radius:  10px 0 0 10px;
  }
   .exhibition-infor .content-left .conent-img > img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 110%;
            height: 110%;
            /* border-radius: 10px 0 0 10px; */
            animation: moveLR 10s linear infinite;
            animation-direction: alternate
}
.box-img {
    position: absolute;
       width: 100%;
        height: 100%;
     left: 0;
     z-index: 2;
    background: #000000;
    opacity: 0.15;

}
@keyframes moveLR {
    0% {
    left: 0;
    top: 0;
    transform: scale(1);
    }
    100% {
        left: -12%;
        top: -11%;
        transform: scale(1.2);
    }
}
.exhibition-infor .content .content-right {
      flex: 320px;
      display: flex;
      flex-wrap: wrap;
      height: 400px;
      background-color: #fff;
      overflow: hidden;
        border-radius: 0 10px 10px 0;

}
  .exhibition-infor .content-right .text-box {
      width: 280px;
      height: 360px;
      padding: 30px 20px 10px;
      padding-bottom: 9%;
      font-size: 14px;
      background-color: #fff;
      overflow: hidden;
}
 .exhibition-infor .content-right .anim-box {
       height: 100%;
 }
  .animate-up {
    transition: all 0.5s ease-in-out;
    transform: translateY(-58px);
  }
  .exhibition-infor .text-box .min-box
{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
}
  .exhibition-infor .text-box span:nth-child(1){
      width: 95%;
    overflow: hidden;
     white-space: nowrap;
        /* 这两个要一起用 */
    text-overflow: ellipsis;
        /* 省略号  */
    margin-bottom: 10px;
    color: #222222;
       cursor: pointer;
}
  .exhibition-infor .text-box span:nth-child(2) {
    margin-bottom: 20px;
    color: #999999;
}

.exhibition-infor .content .current {
            display: block;
}

/* exhibition-infor 展览信息区样式结束 */
/* artwork 藏品类别区样式开始 */
.artwork {
    /* width: 83%; */
    margin: 80px auto 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #fff;
}
.artwork .tip {
    width: 100%;
    height: 80px;
    margin: 60px 0 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* background-color: pink; */

}
.artwork .tip  .tip-left p:nth-child(1)
{
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;
}
.artwork .tip .tip-left p:nth-child(2)
{
    /* margin-top: 10px; */
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
.artwork .content {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
}
.artwork .content .carousel-box {
    width: 100%;


}


::v-deep .artwork  .el-carousel__arrow {
      width: 29px;
      height: 59px;
      border-radius: 0;
      font-size: 30px;
      background-color: #999999;
  }

  ::v-deep  .artwork .el-carousel__arrow--left {
    display: "" !important;
    left: 0px;
}
::v-deep .artwork  .el-carousel__arrow--right {
right: 0px;

}
::v-deep .artwork  .el-carousel__arrow--right:hover {
          background-color: rgba(183,140,13, 1);
             color: rgba(255,255,255, 1);
}
::v-deep .artwork  .el-carousel__arrow--left:hover {
          background-color: rgba(183,140,13, 1);
             color: rgba(255,255,255, 1);
}
::v-deep .artwork  .el-carousel__mask {
    opacity: 0;
}
.artwork .img-box {
    width: 285px;
    height: 320px;
    margin:  0 auto;
    position: relative;
}
.artwork .img-box:hover  .img-box-item{

       background-color: rgba(183,140,13, 0.5);
        color: rgba(255,255,255, 1);
         font-size: 18px;
}
.artwork .img-pic {
    width: 100%;
    height: 100%;
     border-radius: 10px;
    cursor: pointer;
}
.artwork .img-box-item{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    background-color: rgba(183,140,13, 0);
    transition: 0.6s linear;
    color: rgba(255,255,255, 0);
   overflow: hidden;
   font-size: 18px;
    white-space: nowrap;
    /* 这两个要一起用 */
    text-overflow: ellipsis;
    /* 省略号  */
}
/* artwork 藏品类别区样式结束 */

/* news-infor 新闻公告区样式开始 */
.news-infor {
    display: flex;
    margin: 60px auto 0;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #f4f4f4;
}

.news-infor .tip {
    width: 100%;
    height: 80px;

}
.news-infor .tip .title-top {
    width: 333px;
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;

}
.news-infor .tip .title-bottom
{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.news-infor .tip .title-bottom .left
{
    width: 333px;
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
.news-infor .tip .title-bottom .right
{
    width: 98px;
    height: 40px;
    font-size: 36px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
    line-height: 40px;
    cursor: pointer;
}
.news-infor .content {
    width: 100%;
    height: 400px;
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
}
.news-infor .content .content-left {
    position: relative;
    width: 880px;
    height: 100%;
}
.news-infor .content .content-left .news-show {
    width: 100%;
    height: 100%;
    border-radius: 10px 0 0 10px;
}

.news-infor .content .content-right {
      width: 320px;
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      overflow: hidden;
            border-radius:  0 10px 10px 0;
      background-color: #fff;
}
  .news-infor .content-right .text-box {
       /* display: flex;
      flex-wrap: wrap; */
     width: 280px;
      height: 360px;

      padding: 30px 20px 10px;
      font-size: 14px;
      background-color: #fff;
      overflow: hidden;
}
  .news-infor .text-box .min-box
{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;
        white-space: nowrap;
        /* 这两个要一起用 */
        text-overflow: ellipsis;
        /* 省略号  */
}
  .news-infor .text-box span:nth-child(1){
    overflow: hidden;
    white-space: nowrap;
        /* 这两个要一起用 */
    text-overflow: ellipsis;
    margin-bottom: 10px;
    color: #222222;
    width: 95%;
}
  .news-infor .text-box span:nth-child(2) {
    margin-bottom: 20px;
    color: #999999;

}

.news-infor .content .current {
            display: block;
}
/* news-infor 新闻公告区样式结束 */

/* exhibition-infor 展览信息区样式结束 */
/* public-activity 公共活动区样式开始 */
.public-activity {
    /* width: 83%; */
    margin: 60px auto 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #fff;
}
.public-activity .tip {
    width: 100%;
    height: 80px;
    margin: 60px 0 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

}
.public-activity  .tip  .tip-left p:nth-child(1)
{
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;
}
.public-activity  .tip .tip-left p:nth-child(2)
{
    /* margin-top: 10px; */
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
.public-activity .content {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
}
.public-activity .content .carousel-box {
    width: 100%;
    position: relative;

}

  .leftTriangle,
        .rightTriangle {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
            width: 29px;
            height: 59px;
            line-height: 59px;
            font-size: 30px;
            background-color: #999999;
            color: #fff;
            cursor: pointer;
            text-align: center;
            user-select: none;
        }
        .leftTriangle {
            left: 0;
        }
        .rightTriangle {
            right: 0;
        }
         .leftTriangle:hover {
               background-color: rgb(183,140,13);
             color: rgb(255,255,255);
         }
        .rightTriangle:hover {
               background-color: rgb(183,140,13);
             color: rgb(255,255,255);
         }
         /* .hoverBgc {
            background-color: rgb(183,140,13);
             color: rgb(255,255,255);
        } */
::v-deep .public-activity  .el-carousel__arrow {
      width: 29px;
      height: 59px;
      border-radius: 0;
      font-size: 30px;
      background-color: #999999;
  }

    .public-activity >>> .el-carousel__arrow--left {
        display: "block" !important;
    left: 0px;
}
::v-deep .public-activity  .el-carousel__arrow--right {

right: 0px;

}

::v-deep .public-activity  .el-carousel__arrow--right:hover {
          background-color: rgba(183,140,13, 1);
             color: rgba(255,255,255, 1);
}
::v-deep .public-activity  .el-carousel__arrow--left:hover {
          background-color: rgba(183,140,13, 1);
             color: rgba(255,255,255, 1);
}
::v-deep .public-activity .el-carousel__mask {
    opacity: 0;
}
.public-activity .img-box {
      width: 285px;
    height: 320px;
    margin:  0 auto;
    position: relative;
}
.public-activity .img-box:hover .img-box-item{

       background-color: rgba(183,140,13, 0.5);
        color: rgba(255,255,255, 1);
        font-size: 18px;

}
.public-activity .img-pic {
    border-radius: 10px;
    width: 100%;
    height: 100%;
}
 .public-activity .img-box-item{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
      font-size: 18px;
    width: 100%;
    height: 100%;

    background-color: rgba(183,140,13, 0);
    transition: 0.6s linear;
    color: rgba(255,255,255, 0);
    overflow: hidden;
    white-space: nowrap;
    /* 这两个要一起用 */
    text-overflow: ellipsis;
    /* 省略号  */
}
/* public-activity 公共活动区样式结束 */
/* art-brief 美术馆简介区样式开始 */
    .art-brief {
    margin: 60px auto 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    }
    .art-brief .tip {
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .art-brief .tip  .tip-left p:nth-child(1)
{
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;
}
.art-brief  .tip .tip-left p:nth-child(2)
{
    /* margin-top: 10px; */
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
    /* .art-brief .tip > img {
        width: 490px;
        height: 43px;
    } */
     .art-brief .content {
        margin-top: 40px;
         width: 1200px;
         height: 400px;
        position: relative;
     }
     .art-brief .content .conent-img {
         width: 100%;
         height: 100%;
     }
     .art-brief .content .conent-text {
         position: absolute;
         width: 628px;
         height: 200px;
            border-radius:  10px;
         left: 50%;
         top:  50%;
         transform: translate(-50%, -50%);
         background-color: rgba(183,140,13, 0.8);
         color: #fff ;
     }

    .art-brief .conent-text  .text-box {
         width: 549px;
         word-break:break-all;
         margin: 30px auto;
         text-indent: 2em;
         text-align: left;
         font-size: 14px;
         line-height: 26px;
         font-family: SourceHanSansCN-;
         font-weight: 400;
         color: #fff !important;

     }
     ::v-deep .art-brief .conent-text  .text-box p span{

        color: #fff !important;
        font-size: 14px !important;
        font-family: SourceHanSansCN- !important;
     }

/* art-bief 美术馆简介区样式结束 */

/* 学术交流区样式开始 */
    .academic-exchange {

    margin: 60px auto 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #fff;
    }
    .academic-exchange .tip {
        width: 100%;
        height: 80px;
        display: flex;
        margin-top:60px;
        justify-content: flex-start;
        align-items: center;
    }
       .academic-exchange .tip  .tip-left p:nth-child(1)
{
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;
}
.academic-exchange  .tip .tip-left p:nth-child(2)
{
    /* margin-top: 10px; */
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
    .academic-exchange .tip > img {
        width: 301px;
        height: 49px;
    }
     .academic-exchange .content {
        margin-top: 40px;
           margin-bottom:60px;
        display: flex;

     }
      .academic-exchange .content .content-left {
            width: 443px;
          height: 320px;
          margin-right: 30px;
              position: relative;

      }
            .academic-exchange .content-left >img {

             width: 100%;
                height: 100%;
                    border-radius: 10px;
            }

            .academic-exchange .content-left:hover .image-mask {

                     background-color: rgba(183,140,13, 0.5);
                    color: rgba(255,255,255, 1);
                    font-size: 18px;
            }
        .image-mask {
			    position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
			    width: 100%;
				height: 100%;
				top: 0;
                left: 0;
			    background-color: rgba(183,140,13, 0);
                border-radius: 10px;
                transition: 0.6s linear;
                color: rgba(255,255,255, 0);
                font-size: 18px;
                cursor: pointer;
			}

       .academic-exchange .content .content-right {
               width: 443px;
          height: 320px;
          border-radius: 10px;
            position: relative;
      }
        .academic-exchange .content-right:hover .image-mask {

                     background-color: rgba(183,140,13, 0.5);
                    color: rgba(255,255,255, 1);
                    font-size: 18px;
            }

            .academic-exchange .content-right >img {
                width: 100%;
                height: 100%;
                    border-radius: 10px;
            }

/* 学术交流区样式结束 */

/* 服务指南区样式开始 */
.service-guide {

     margin: 60px auto 0;
     display: flex;
     justify-content: center;
     flex-wrap: wrap;
}
 .service-guide .tip {
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
        .service-guide .tip  .tip-left p:nth-child(1)
{
    height: 50px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #222222;
    line-height: 50px;
}
.service-guide  .tip .tip-left p:nth-child(2)
{
    /* margin-top: 10px; */
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    font-family: DengXian;
    font-weight: 300;
    color: #B78C0D;
}
    /* .service-guide .tip > img {
        width: 286px;
        height: 43px;
    } */
      .service-guide .content {
          width: 100%;
        margin-top: 40px;

        display: flex;
        flex-wrap: wrap;

     }
  .service-guide .map-tip {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding-top: 30px;
      padding-bottom: 60px;
      background-color: #fff;
  }
  .service-guide .map-tip .left {
      margin-left: 20px;
      width: 100%;
  }
   .service-guide .map-tip .title {
       width: 100%;
       color:  #222222;
       font-size: 18px;
   }
   .service-guide .map-tip .tip-content {
       width: 100%;
       margin-top: 20px;
       color: #999999;
       font-size: 14px;
       line-height: 26px;
   }
    .service-guide .map-tip .right {
        width: 100%;
        margin-right: 20px;
    }
    .service-guide .map-tip .button {
        width: 100%;
        height: 100%;
        display: flex;
        font-size: 18px;
        justify-content: flex-end;
        align-items: flex-end;
    }
   .service-guide .map-tip .button a{
       display: block;
       width: 200px;
       height: 40px;
       border: 1px solid #B78C0D;
       color: #B78C0D;
       text-align: center;
       line-height: 40px;
       cursor: pointer;
   }




/* 服务指南区样式结束 */
/* 链接推荐样式开始 */
.dw {
    width: 100%;
    height: auto;
     background: url("../assets/imgs/dw.png") no-repeat;
     background-size: 100% 100%;
}
.link-record{

     margin: 0 auto ;
     padding-top: 130px;
     padding-bottom: 60px;
     display: flex;
     /* justify-content: center; */
     flex-wrap: wrap;

}
.link-record .link {
    width: 100%;
    display: flex;
     margin-top: 20px;

}
.link-record .link span {
      margin-right: 30px;
    color: #222222;
    font-size: 18px;

}
.link-record a {
    margin-right: 40px;
       color: #222222;
    font-size: 18px;
}

.link-record .record {
    display: flex;
     width: 100%;


    justify-content: space-between;
    align-items: flex-end;

}
.link-record .record .content {
       line-height: 24px;
       font-size: 14px;
}
.link-record .record .erweima >img {
    width: 136px;
    height: auto;
}
/* 链接推荐样式结束 */
</style>
